export default __webpack_public_path__ + "locales/ko-KR/EmbeddingPanel.json?hash=3df6b26e74e26fc470012abe1db76b07";